<template>
  <div>
    <user-detail-title
        first-bread="用户管理"
        second-bread="用户管理添加"
        first-url="/user/manage"
        title-name="用户管理添加"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="Alist.userName" ></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="Alist.password" ></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ManageAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Alist: {
          'userName':null,
          'password':null,
        },//表示Add添加的数据
      }
    },
    methods:{
      handleAdd(){
        this.$axios.post('/api/user/addUser',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'userName':null,
              'password':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>